export const pkg = {
  name: 'isomorphic-git',
  version: '1.31.0',
  agent: 'git/isomorphic-git@1.31.0',
}
